import { render, staticRenderFns } from "./HistoriesView.vue?vue&type=template&id=79a10d98&scoped=true"
import script from "./HistoriesView.vue?vue&type=script&lang=js"
export * from "./HistoriesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a10d98",
  null
  
)

export default component.exports